import { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { IconChevronDown } from "@tabler/icons-react";

export default function SideBarMenu({ curElm, isActiveLink }) {
  const childs = curElm.childs || [];
  const [isOpen, setIsOpen] = useState(false);

  const location = useLocation();
  const isActiveParent =
    location.pathname === curElm.link ||
    childs.some((c) => c.link === location.pathname);

  const toggleSubMenu = (e) => {
    e.preventDefault();
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    const allLinks = [curElm.link, ...childs.map((c) => c.link)];
    if (!allLinks.includes(location.pathname)) {
      setIsOpen(false);
    }
  }, [location.pathname, curElm.link, childs]);

  return (
    <>
      <NavLink
        to={curElm.link || "#"}
        state={{
          edit: curElm?.edit,
          add: curElm?.add,
          delete: curElm?.delete,
          view: curElm?.view,
          export: curElm?.export,
        }}
        className={`sidebar-link ${isActiveParent ? "subMenu-active" : ""} ${!isActiveLink ? "justify-between" : "justify-center"} w-full`}
        onClick={childs.length > 0 ? toggleSubMenu : null}
      >
        <div className="flex items-center space-x-2">
          <span>{curElm.icon}</span>
          {!isActiveLink && (
            <h1 className="mb-0 title-font-700 fs-5 base-font-muli fw-bold">
              {curElm.title}
            </h1>
          )}
        </div>
        {childs.length > 0 && (
          <div className="mr-4">
            {!isActiveLink && (
              <IconChevronDown stroke={1.5} size={23} className={`transition-all duration-300 ${isOpen ? "-rotate-180" : ""} ${isActiveParent ? "text-white" : "text-black"}`}  />
            )}
          </div>
        )}
      </NavLink>
      {isOpen && (
        <div className="subMenu-card">
          {childs.map(
            (child, index) =>
              child.view && (
                <NavLink
                  to={child.link}
                  state={{
                    edit: child?.edit,
                    add: child?.add,
                    delete: child?.delete,
                    view: child?.view,
                    export: child?.export,
                  }}
                  key={index}
                  className={`sidebar-link submenu-link ${!isActiveLink ? "pl-3 pr-4 justify-between" : "justify-center items-center"}`}
                >
                  <span className="d-flex gap-2 align-items-center pl-4">
                    {child.icon}
                    {!isActiveLink && (
                      <h5 className="mb-0 title-font-700 fs-5 base-font-muli fw-bold submenu-title">
                        {child.label}
                      </h5>
                    )}
                  </span>
                </NavLink>
              ),
          )}
        </div>
      )}
    </>
  );
}
